import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useTemplateMutations from "../../../datahooks/useTemplateMutations";

export default function DeleteTemplateContent({
  templateName,
  templateId,
  onCancel,
}: {
  templateName: string;
  templateId: string;
  onCancel: () => void;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();
  const { search } = useLocation();

  const { deleteTemplate, isDeletingTemplate } = useTemplateMutations();

  function removeTemplate() {
    deleteTemplate({ templateId }).then(() => {
      navigate({ pathname: "..", search });
    });
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title={
          <>
            Delete &quot;{templateName}
            &quot; template?
          </>
        }
        subtitle="Campaigns using this template will continue normally, but you will not be able to add it to new campaigns"
      />

      <Footer className="justify-end">
        <Button
          data-cy="delete-template-button"
          variant="outline-danger"
          onClick={removeTemplate}
          isLoading={isDeletingTemplate}
        >
          Delete
        </Button>
        <Button
          variant="secondary-black"
          onClick={onCancel}
          disabled={isDeletingTemplate}
        >
          Cancel
        </Button>
      </Footer>
    </>
  );
}
